import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import template from './palette.jsx';
import displayNames from '../displayNames';

var _getDistanceToWhite = function getDistanceToWhite(hexColor) {
  return _(hexColor).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value();
};

var DEFAULT_COLORS = _.unzip([['#FFFFFF', '#D9F0FD', '#ADC6F8', '#C4AEDD', '#E5FAD1'], ['#E8E6E6', '#BEE5FB', '#83A8F0', '#9C7FBA', '#CAE5AF'], ['#C7C7C7', '#7FCCF7', '#155DE9', '#663898', '#9BCB6C'], ['#999997', '#40667C', '#0E3E9B', '#442565', '#4E6636'], ['#414141', '#213D4D', '#071F4E', '#221333', '#27331B']]);

var Palette = /*#__PURE__*/function (_React$Component) {
  _inherits(Palette, _React$Component);

  var _super = _createSuper(Palette);

  function Palette(props) {
    var _this;

    _classCallCheck(this, Palette);

    _this = _super.call(this, props);
    _this.state = {
      colorIndex: _.indexOf(_this.getColorsByPalette(_this.props.palette), _this.props.value)
    };

    _this.onChange = function (color, colorIndex) {
      _this.setState({
        colorIndex: colorIndex
      }, function () {
        _this.props.onChange(color, colorIndex);
      });
    };

    return _this;
  }

  _createClass(Palette, [{
    key: "getDistanceToWhite",
    value: function getDistanceToWhite(hex) {
      return _getDistanceToWhite(hex);
    }
  }, {
    key: "getColorsByPalette",
    value: function getColorsByPalette(palette) {
      return _(palette).unzip().flatten().value();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var palette = this.getColorsByPalette(nextProps.palette);
      var currentColor = palette[this.state.colorIndex];

      if (nextProps.value !== currentColor) {
        this.setState({
          colorIndex: _.indexOf(palette, nextProps.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return Palette;
}(React.Component);

Palette.displayName = displayNames.PALETTE;
Palette.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onMainColorChange: PropTypes.func,
  onColorEnter: PropTypes.func,
  onColorLeave: PropTypes.func,
  palette: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  mainColors: PropTypes.arrayOf(PropTypes.string)
};
Palette.defaultProps = {
  palette: DEFAULT_COLORS,
  onColorEnter: _.noop,
  onColorLeave: _.noop,
  onChange: _.noop,
  onMainColorChange: _.noop
};
export default compose(Palette);